import React, { useState } from "react";
import emailjs from 'emailjs-com';

const Support = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission logic here
      e.preventDefault();
      setLoading(true);
  
      let {name, message, email} = formData;
      const templateParams = {
        from_name: name,
        message: message,
        reply_to: email
      };
  
      // Replace 'YOUR_SERVICE_ID', 'YOUR_TEMPLATE_ID', and 'YOUR_USER_ID' with your EmailJS credentials
      emailjs.send('service_kads4io', 'template_puwrxf8', templateParams, 'Swde8gZvFf-9AB9lH')
        .then((response) => {
          console.log('SUCCESS!', response.status, response.text);
          alert('Message sent successfully!');
          setLoading(false);
          setFormData({
            name: "",
            email: "",
            message: "",
          })
          // Handle success (e.g., show a success message)
        }, (err) => {
          console.log('FAILED...', err);
          setLoading(false);
          alert('Something went wrong!');
          // Handle errors
        });
  };

  return (
    <div className="container mx-auto mt-8 mb-10">
      <h1 className="text-3xl font-bold mb-6 text-center">
        Get in Touch with Support
      </h1>

      <p className="text-lg text-gray-700 mb-8 text-center">
        If you have any questions or issues, feel free to reach out to our
        support team.
      </p>
      <form
        onSubmit={handleSubmit}
        className="max-w-md mx-auto bg-white p-8 rounded-md shadow-md"
      >
        <h2 className="text-2xl font-bold mb-6 text-center">Contact Support</h2>

        <div className="mb-4">
          <label
            htmlFor="name"
            className="block text-gray-700 text-sm font-bold mb-2"
          >
            Name
          </label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:border-blue-500"
            required
          />
        </div>

        <div className="mb-4">
          <label
            htmlFor="email"
            className="block text-gray-700 text-sm font-bold mb-2"
          >
            Email
          </label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:border-blue-500"
            required
          />
        </div>

        <div className="mb-6">
          <label
            htmlFor="message"
            className="block text-gray-700 text-sm font-bold mb-2"
          >
            Message
          </label>
          <textarea
            id="message"
            name="message"
            value={formData.message}
            onChange={handleChange}
            className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:border-blue-500"
            rows="4"
            required
          ></textarea>
        </div>

        <button
          type="submit"
          disabled={loading}
          className="w-full bg-blue-500 text-white p-2 rounded hover:bg-blue-600 focus:outline-none"
        >
          {loading? 'Submiting...': 'Submit'}
        </button>
      </form>
      {/* <SupportForm /> */}
    </div>
  );
};

export default Support;
